<app-help-center></app-help-center>

<div *ngIf="!(isAuthenticated$ | async).isAuthenticated">
  <app-bottom-menu></app-bottom-menu>
</div>
